import { useEffect } from "react";
import ReportUtils from "../../../../../utils/report-utils.js";

export default function ReportContent({ data, tableColumns }) {
    useEffect(() => {
        ReportUtils.createExportableTable(null, null, "Despacho por local", "dispatch-by-place-export-data",);
    }, [data, tableColumns]);

    const columns = [
        {
            id: "place",
            className: "w-[25%]",
            render: (item) =>
                item.place ?? (
                    <span className="italic text-[#898989]">Não informado</span>
                ),
            export: (item) => item.place ?? "-",
        },
        {
            id: "street",
            className: "w-[30%]",
            render: (item) => (
                <>
                    {item.street ?? (
                        <span className="italic text-[#898989]">Não informado</span>
                    )}
                    {item.number ? `, ${item.number}` : ""}
                </>
            ),
            export: (item) => item.street ?? "-",
        },
        {
            id: "neighborhood",
            className: "w-[25%]",
            render: (item) =>
                item.neighborhood ?? (
                    <span className="italic text-[#898989]">Não informado</span>
                ),
            export: (item) => item.neighborhood ?? "-",
        },
        {
            id: "sector",
            className: "w-[10%]",
            render: (item) =>
                item.sectors || (
                    <span className="italic text-[#898989]">Não informado</span>
                ),
            export: (item) => item.sectors ?? "",
        },
        {
            id: "quantity",
            className: "w-[10%]",
            render: (item) => item.ids_count ?? "",
            export: (item) => item.ids_count ?? "",
        },
    ];

    const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
    );

    const exportNumber = visibleColumns.some((column) => column.id === "street");

    return (
        <>
            {visibleColumns.length ? (
                <>
                    <table className="table report-table" sheet-name="Despacho por local">
                        <thead className="thead-background">
                            <tr className="bg-[#f6f6f6] text-left">
                                {visibleColumns.map((column) => (
                                    <th key={column.id} className={column.className}>
                                        {tableColumns[column.id].label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {data.map((item, index) => (
                                <tr key={index} className="table-break-word">
                                    {visibleColumns.map((column) => (
                                        <td key={column.id}>{column.render(item)}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <table id="dispatch-by-place-export-data" className="hidden" sheet-name="Despacho por local">
                        <thead>
                            <tr>
                                {visibleColumns.map((column) => (
                                    <th key={column.id}>{tableColumns[column.id].label}</th>
                                ))}

                                {exportNumber && <th>Número</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    {visibleColumns.map((column) => (
                                        <td key={column.id}>{column.export(item)}</td>
                                    ))}

                                    {exportNumber && <td>{item.number ?? "-"}</td>}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            ) : (
                <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}

            <div id="chart-tables"/>
        </>
    );
}